:host {
  position: absolute;
  z-index: 2;
  top: 0;
  left: 0;
  width: 100%;
  font-family: var(--font-family-sans);
  font-weight: var(--font-rg);
}

:host > z-alert {
  height: calc(var(--space-unit) * 6);
}

.relative-container {
  position: relative;
  display: grid;
  align-items: center;
  padding: 0;
  grid-column-gap: var(--space-unit);
  grid-template-columns: 18px auto 46px;
  grid-template-rows: 1fr;
  outline: none;
}

.relative-container::-moz-focus-inner {
  border: 0;
}

.alert-external-wrapper.remove-alert {
  border: var(--border-size-medium) solid var(--color-background);
  border-top: none;
}

:host div.add-alert {
  background: var(--color-inverse-success);
}

:host div.remove-alert {
  background: var(--color-inverse-warning);
}

:host div > .content-text {
  color: var(--color-surface05);
  font-size: 14px;
  letter-spacing: 0.16px;
  line-height: 20px;
}

:host div > .content-action {
  height: 20px;
  color: var(--color-primary01);
  cursor: pointer;
  font-size: 12px;
  font-weight: var(--font-sb);
  letter-spacing: 0.32px;
  line-height: 20px;
}

:host div > z-icon {
  justify-self: center;
}
